import React from 'react';

import BaseForm from './BaseForm';

class InvoiceForm extends React.Component {
    render() {
        return <BaseForm
            domRef={this.props.domRef}
            formId="invoice"
            isOpen
            showHeader={this.props.showHeader}
            header="Förläng Studentförsäkring Leva"
            body={"Det enda du behöver göra för att behålla Studentförsäkring Leva är att klicka på \"Förläng nu\" så kommer ett inbetalningskort med posten. Tryggt och enkelt."}
            onSubmit={this.props.onSubmit}
            onFormHeaderClick={ e => this.props.onFormHeaderClick() }
            termsAndConditionsUrl={this.props.termsAndConditionsUrl}
        />;
    }
}

// state

export default InvoiceForm;